@use "@fukuri-admins/ui/layout" as *;

.emptyTable {
  height: 326px;
  margin: 100px auto;
  font-size: 40px;
  color: $NATURAL_400;
  text-align: center;
}
